export default {"src":"/_next/static/media/imageHeaderLanguage.3ae2e8b9.svg","height":190,"width":296,"blurWidth":0,"blurHeight":0};